import React from 'react';
import PrivateRoute from 'components/common/PrivateRoute';
import {Container} from 'semantic-ui-react';
import HeaderContainer from '../components/Header/HeaderContainer';
import DeleteBreakModalContainer from 'pages/DeleteConfirmation/DeleteConfirmationModalContainer';
import ForgotPasswordModalContainer from 'pages/Login/ForgotPasswordModalContainer';
import Home from './Home.jsx';
import ListBreaksPage from 'pages/ListBreaks/ListBreaksPage.jsx';
import BreakPagesContainer from './BreakPagesContainer';
import EditHomepageLayoutsPageContainer from 'pages/EditHomepageLayoutsPage/EditHomepageLayoutsPageContainer';
import UGCModerationPage from 'pages/UGCModeration/UGCModerationPage';
import UGCCampaignPage from 'pages/UGCModeration/UGCCampaignPage';
import EditPrizePageContainer from 'pages/EditPrize/EditPrizePageContainer';
import UserPageContainer from 'pages/UserManagement/UserPageContainer';
import FeaturedManagerPage from 'pages/FeaturedManager/FeaturedManagerPage';
import ImagePage from 'pages/Images/ImagesPage';
import RewardsDashboard from 'pages/Rewards/RewardsDashboard/RewardsDashboard';
import RewardsTableViewContainer from 'pages/Rewards/RewardsTable/RewardsTableViewContainer';
import ListPrizesNav from 'pages/ListPrizes/ListPrizesNav';
import ListWinnersNav from 'pages/ListWinners/ListWinnersNav';
import ListEntriesPage from 'pages/ListEntries/ListEntriesPage';
import MultipleWinnersPage from 'pages/MultipleWinners/MultipleWinnersPage';
import ProfilePageContainer from 'pages/Profile/ProfilePageContainer';
import MaintenancePage from 'pages/Maintenance/MaintenancePage';
import PublishLogDownload from "./PublishLogDownload/PublishLogDownload";
import {PermissionsFilter, UserGroupFilter} from 'hoc/authorization';
import NoAccessPage from 'pages/NoAccessPage';
import * as ResourceApi from 'api/resources';
import {UserGroups} from 'utils/DBUtils';

// most routes are locked by Resource READ and DOWNLOAD permissions; in some cases, where
// a route defined here defers to a component that renders a react-router <Switch>, the
// permissions are set in that component instead of here.


// UGC

const withUGCSubmissionReadPermissions = PermissionsFilter({
  [ResourceApi.Types.UGCSubmission]: ['READ']
});

const LockedUGCModerationPage = withUGCSubmissionReadPermissions(UGCModerationPage);
const LockedUGCCampaignPage = withUGCSubmissionReadPermissions(UGCCampaignPage);


// Rewards

const withRetailerItemReadPermissions = PermissionsFilter({
  [ResourceApi.Types.RetailerItem]: ['READ']
});

const LockedRewardsDashboard = withRetailerItemReadPermissions(RewardsDashboard);
const LockedRewardsTableViewContainer = withRetailerItemReadPermissions(RewardsTableViewContainer);


// Prizing

const LockedEditPrizePageContainer = PermissionsFilter({
  [ResourceApi.Types.Prize]: ['READ']
})(EditPrizePageContainer);

const LockedListEntriesPage = PermissionsFilter({
  [ResourceApi.Types.PrizeEntry]: ['READ'],
  [ResourceApi.Types.Prize]: ['READ']
})(ListEntriesPage);

const LockedMultipleWinnersPage = PermissionsFilter({
  [ResourceApi.Types.PrizeEntry]: ['READ'],
  [ResourceApi.Types.Prize]: ['READ']
})(MultipleWinnersPage);

const LockedPublishLogDownload = PermissionsFilter({
  [ResourceApi.Types.PublishLogReport]: ['DOWNLOAD']
})(PublishLogDownload);


// misc.

const LockedMaintenancePage = UserGroupFilter(
  UserGroups.Root
)(MaintenancePage);

const LockedFeaturedManagerPage = PermissionsFilter({
  [ResourceApi.Types.FeaturedManager]: ['Read']
})(FeaturedManagerPage);


const Main = props => (
  <div>
    <ForgotPasswordModalContainer/>
    <DeleteBreakModalContainer />
    <HeaderContainer router={props} />
    <Container className="page-container">
      <PrivateRoute exact path='/' component={Home} />
      <PrivateRoute path='/no-access' component={NoAccessPage} />
      <PrivateRoute path='/breaks' component={ListBreaksPage} />
      <PrivateRoute path='/break/:breakId' component={BreakPagesContainer} />
      <PrivateRoute path="/images" component={ImagePage} />
      <PrivateRoute exact path='/ugc' component={LockedUGCModerationPage} />
      <PrivateRoute path='/ugc/:masterCampaignId' 
                    component={ (props) => <LockedUGCCampaignPage {...props} ugcResourceType={ResourceApi.Types.UGCSubmission} /> }/>
      <PrivateRoute path='/receipt/:masterCampaignId' 
                    component={ (props) => <LockedUGCCampaignPage {...props} ugcResourceType={ResourceApi.Types.UGCReceiptSubmission} /> }
                    />
      <PrivateRoute exact path="/rewards" component={LockedRewardsDashboard} />
      <PrivateRoute path="/rewards/:lang/:year/:month/" component={LockedRewardsTableViewContainer} />
      <PrivateRoute path="/prizes/:prizeType" component={ListPrizesNav} />
      <PrivateRoute path="/winners/:prizeType" component={ListWinnersNav} />
      <PrivateRoute path="/entries/:prizeType/:prizeId" component={LockedListEntriesPage} />
      <PrivateRoute path="/prize/:prizeId/edit" component={LockedEditPrizePageContainer} />
      <PrivateRoute path="/prize/:prizeId/winners" component={LockedMultipleWinnersPage} />
      <PrivateRoute path="/homepagelayouts" component={EditHomepageLayoutsPageContainer} />
      <PrivateRoute path='/user*' component={UserPageContainer} />
      <PrivateRoute path="/profile"  component={ProfilePageContainer} />
      <PrivateRoute path="/publishlog"  component={LockedPublishLogDownload} />
      <PrivateRoute path="/maintenance"  component={LockedMaintenancePage} />
      <PrivateRoute path="/tools/featured-manager" component={LockedFeaturedManagerPage} />
    </Container>
  </div>
);

export default Main;



// WEBPACK FOOTER //
// ./public/pages/Main.jsx